import React, { useEffect } from "react";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

const OAuthCallback = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Parse URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const success = urlParams.get("success");
    const error = urlParams.get("error");
    const platform = urlParams.get("platform");
    const username = urlParams.get("username");
    const code = urlParams.get("code");
    const access_token = urlParams.get("access_token");

    // Send message to parent window
    if (window.opener) {
      if (success === "true") {
        window.opener.postMessage(
          {
            type: "OAUTH_SUCCESS",
            platform: platform,
            username: username,
            code: code,
            access_token: access_token,
            // For Instagram, we might get additional user info from the callback
            platform_user_id: urlParams.get("platform_user_id"),
            user_info: urlParams.get("user_info")
              ? JSON.parse(decodeURIComponent(urlParams.get("user_info")))
              : {},
          },
          window.location.origin
        );
      } else if (error) {
        window.opener.postMessage(
          {
            type: "OAUTH_ERROR",
            platform: platform,
            error: error,
          },
          window.location.origin
        );
      }

      // Close popup after a short delay
      setTimeout(() => {
        window.close();
      }, 1500);
    } else {
      // If not in popup, redirect to dashboard
      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 2000);
    }
  }, []);

  // Parse URL to show appropriate message
  const urlParams = new URLSearchParams(window.location.search);
  const success = urlParams.get("success");
  const error = urlParams.get("error");
  const platform = urlParams.get("platform");
  const username = urlParams.get("username");

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={3}
      textAlign="center"
    >
      {success === "true" ? (
        <>
          <Box mb={2}>
            <Typography variant="h5" color="success.main" gutterBottom>
              ✅ {t("oauth.success.title", "Connection Successful!")}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              {t(
                "oauth.success.message",
                `Your ${platform} account${
                  username ? ` (@${username})` : ""
                } has been connected successfully.`
              )}
            </Typography>
          </Box>
          <CircularProgress color="success" size={24} />
          <Typography variant="caption" color="textSecondary" mt={1}>
            {t("oauth.success.closing", "Closing window...")}
          </Typography>
        </>
      ) : error ? (
        <>
          <Alert severity="error" sx={{ mb: 2, maxWidth: 400 }}>
            <Typography variant="h6" gutterBottom>
              {t("oauth.error.title", "Connection Failed")}
            </Typography>
            <Typography variant="body2">
              {t(
                "oauth.error.message",
                `Failed to connect ${platform}: ${error}`
              )}
            </Typography>
          </Alert>
          <Typography variant="caption" color="textSecondary">
            {t("oauth.error.closing", "This window will close automatically.")}
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            {t("oauth.processing.title", "Processing Connection...")}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {t(
              "oauth.processing.message",
              "Please wait while we complete your OAuth connection."
            )}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default OAuthCallback;
